import React from 'react';
import { formatCurrencyStyled } from '../visuals/currency.formatted';

import './numberDIsplay.scss';

interface NumberDisplayProps {
    title: string;
    value: number;
    icon: 'arrow_upward' | 'arrow_downward' | 'warning' | 'account_balance';
    coloring: 'green' | 'gray' | 'red' | 'orange';
    addClass?: string;
}

function NumberDisplay({ title, addClass = '', value, coloring, icon }: NumberDisplayProps) {

    return (
        <div className={`_numberDisplay ${addClass} ${!icon ? '_noIcon' : ''}`}>
            <div className="text">
                <h2>
                    {formatCurrencyStyled(value || 0)}

                </h2>
                <p>{title}</p>
            </div>
            {
                icon ?
                    <div className={`icon ${coloring ? coloring : ''} ${icon === 'warning' ? 'noBold' : ''}`}>
                        <span className="material-icons">
                            {icon}
                        </span>
                    </div>
                    : null
            }
        </div>
    )
}

export default NumberDisplay;
